import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Disclosure } from "@headlessui/react";
import {
  Bars2Icon,
  XMarkIcon,
  ArrowRightOnRectangleIcon,
} from "@heroicons/react/24/outline";
import { Secundary } from "../buttons/navigation/Secundary";
import { navLogin } from "./options/MenuOptions";
// Dropdown
import MyCount from "./dropdown/MyCount";
import Access from "./dropdown/Access";

import { closeSession } from "../../utils/closeSession";
import { HttpRequest } from "../../services/httpRequest";
import { variablesGlobales } from "../../configs/variables";
import { InfoAlert } from "../alerts/infoAlert";
import { useMobileDetection } from "../../hooks/use-mobile-detection";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function NavbarIndex(props) {
  const navigate = useNavigate();
  const hasToken = localStorage.getItem("token");
  const hasTokenJWT = localStorage.getItem("token_jwt");
  const typeUSer = localStorage.getItem("type_user");
  const doc = localStorage.getItem("doc");
  const [firstname, setFirstname] = useState("");

  const [messsageAlert, setMessageAlert] = useState("");
  const [alertSession, setAlertSession] = useState(false);

  const [isOpenInfo, setIsOpenInfo] = useState(false);

  const [visible, setVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isTop, setIsTop] = useState(true);
  const { isDesktop } = useMobileDetection();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY === 0) {
        setIsTop(true); // Si está en la parte superior, bg-darkBg
        setVisible(true);
      } else {
        setIsTop(false);
        if (currentScrollY > lastScrollY) {
          setVisible(false); // Ocultar navbar al hacer scroll hacia abajo
        } else {
          setVisible(true); // Mostrar navbar al hacer scroll hacia arriba
        }
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const handleOpenAlertInfo = (type, message, isOpen) => {
    /* if (type === "success") {
      setMessageAlert(message);
      setAlertSession(isOpen);
      setIsOpenSuccess(isOpen);
    } */

    if (type === "info") {
      setMessageAlert(message);
      setAlertSession(isOpen);
      setIsOpenInfo(isOpen);
    }

    if (type === "error") {
      setMessageAlert(message);
      setAlertSession(isOpen);
    }

    setTimeout(() => {
      setMessageAlert("");
      setAlertSession(!isOpen);
      setIsOpenInfo(!isOpen);
    }, 6000);
  };

  const handleCloseSession = () => {
    closeSession();
    navigate("/ingresar");
  };

  const handleNavigatePayment = () => {
    if (hasTokenJWT) {
      return navigate("/pagar");
    }

    handleOpenAlertInfo("info", "No tienes una cuenta iniciada, por favor inicia una", true);
    setTimeout(() => {
      return navigate("/ingresar");
    }, 3000);
  };

  const loadInfoUser = useCallback(async () => {
    try {
      const data = await HttpRequest.getInfoUser(doc);
      return data?.message?.info;
    } catch (error) {
      console.log(error);
    }
  }, [doc]);

  const navigation = [
    {
      name: "Requisitos",
      href: "/requisitos",
      current: props.current6,
    },
    {
      name: "Tasas y tarifas",
      href: "/tarifas",
      current: props.current3,
    },
    {
      name: "Preguntas frecuentes",
      href: "/faqs",
      current: props.current5,
    },
    {
      name: "Nosotros",
      href: "/nosotros",
      current: props.current2,
    },
  ];

  useEffect(() => {
    const loadInfo = async () => {
      let info = await loadInfoUser();
      return info;
    };

    loadInfo()
      .then((basicInfo) => {
        setFirstname(basicInfo?.firstname);
      })
      .catch((e) => console.log(e));
  }, [loadInfoUser]);

  return (
    <>
      {alertSession && (
        <>
          <InfoAlert
            isOpen={isOpenInfo}
            message={messsageAlert}
            isDesktop={isDesktop}
          ></InfoAlert>
        </>
      )}
      <Disclosure as="nav">
        {({ open }) => (
          <nav
            className={`fixed top-0 left-0 w-full transition-transform duration-300 ease-in-out ${
              visible
                ? open
                  ? "bg-white text-tdark shadow-lg" // Cuando el menú está abierto
                  : isTop
                    ? "bg-darkBg text-white" // Navbar en la parte superior
                    : "bg-white text-tdark shadow-lg" // Navbar después de hacer scroll
                : "-translate-y-full"
            } z-30 font-walsheim text-lg`}
          >
            <>
              <div className="px-4 sm:px-6 2xl:px-36">
                <div className="flex justify-between h-24">
                  <div className="grid content-center">
                    <div className="flex gap-4">
                      <a className="flex items-center" href="/">
                        <img
                          className="block md:hidden h-12 w-auto"
                          src={
                            open
                              ? "/svg/imagotipo-galilea-14.svg" // Logo cuando el menú está abierto
                              : isTop
                                ? "/svg/imagotipo-galilea-15.svg" // Logo normal en top
                                : "/svg/imagotipo-galilea-14.svg" // Logo cuando se hace scroll
                          }
                          alt="Galilea"
                        />
                        <img
                          className="hidden md:block h-12 w-auto"
                          src={
                            open
                              ? "/svg/imagotipo-galilea-14.svg" // Logo cuando el menú está abierto
                              : isTop
                                ? "/svg/imagotipo-galilea-02.svg" // Logo normal en top
                                : "/svg/imagotipo-galilea-01.svg" // Logo cuando se hace scroll
                          }
                          alt="Galilea"
                        />
                      </a>
                      <div className="hidden xl:flex sm:space-x-8 px-4">
                        {navigation.map((item) => (
                          <a
                            key={item.name}
                            href={item.href}
                            className={classNames(
                              item.current
                                ? "relative font-bold after:absolute after:h-1 after:rounded-full after:w-full after:bg-purple"
                                : "",
                              "relative px-1 pt-1 inline-flex items-center after:absolute after:h-1 after:rounded-full after:w-[0%] after:bg-purple after:duration-300 after:z-0 after:bottom-0 hover:after:w-full",
                            )}
                          >
                            {item.name}
                          </a>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="ml-0 hidden xl:flex lg:items-center">
                    <div className="pr-4">
                      <Secundary text="Pagar mi cuota" onClick={handleNavigatePayment} />
                    </div>

                    {hasToken &&
                    typeUSer === variablesGlobales.typeUSerClient ? (
                      <MyCount name={firstname}></MyCount>
                    ) : (
                      <Access></Access>
                    )}
                  </div>

                  <div className="sm-mr-2 flex items-center xl:hidden">
                    {/* Mobile menu button */}
                    <Disclosure.Button
                      className={`inline-flex items-center justify-center focus:rounded-red rounded-full p-2 ${
                        open
                          ? "text-tdark"
                          : isTop
                            ? "text-white"
                            : "text-tdark"
                      } focus:bg-berry/25 focus:outline-hidden`}
                    >
                      {open ? (
                        <XMarkIcon
                          className="block h-6 w-6"
                          aria-hidden="true"
                        />
                      ) : (
                        <>
                          <span className="pr-2 font-medium">Menú</span>
                          <Bars2Icon
                            className="block h-6 w-6"
                            aria-hidden="true"
                          />
                        </>
                      )}
                    </Disclosure.Button>
                  </div>
                </div>
              </div>

              <Disclosure.Panel className="xl:hidden">
                <div className="pt-2 pb-3 space-y-1">
                  {navigation.map((item) => (
                    <Disclosure.Button
                      as="a"
                      key={item.name}
                      href={item.href}
                      className={classNames(
                        item.current
                          ? "font-bold border-tdark"
                          : "hover:border-tdark hover:font-bold border-transparent",
                        "text-base block pl-3 pr-4 py-2 border-l-4",
                      )}
                    >
                      {item.name}
                    </Disclosure.Button>
                  ))}
                </div>
                {hasToken && typeUSer === variablesGlobales.typeUSerClient ? (
                  <div className="pt-4 pb-3 border-t border-gray-200">
                    <div className="mt-3 space-y-1">
                      <div className="px-4 py-2">
                        <span className="block py-2 text-lg font-bold">
                          Hola, {firstname}
                        </span>
                        {navLogin.map((item) => (
                          <Disclosure.Button
                            as="a"
                            key={item.name}
                            href={item.href}
                            className="block py-2 text-base hover:font-bold"
                          >
                            {item.name}
                          </Disclosure.Button>
                        ))}
                        <hr className="mt-4 text-purple/40" />

                        <div className="flex" onClick={handleCloseSession}>
                          <ArrowRightOnRectangleIcon className="w-4 h-auto" />
                          <span className="ml-2 text-sm">Cerrar sesión</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="pl-4 pb-4">
                    <Access></Access>
                  </div>
                )}
              </Disclosure.Panel>
            </>
          </nav>
        )}
      </Disclosure>
    </>
  );
}
